import _asyncToGenerator from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _defineProperty from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/opt/build/repo/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/regenerator/index.js";
import * as React from 'react';
import copy from 'clipboard-copy';
import { useTheme, styled, alpha } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Fade from '@mui/material/Fade';
import MDButton from '@mui/material/Button';
import Box from '@mui/material/Box';
import MDToggleButton from '@mui/material/ToggleButton';
import MDToggleButtonGroup, { toggleButtonGroupClasses } from '@mui/material/ToggleButtonGroup';
import SvgIcon from '@mui/material/SvgIcon';
import Snackbar from '@mui/material/Snackbar';
import Menu from '@mui/material/Menu';
import MDMenuItem, { menuItemClasses } from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Tooltip from '@mui/material/Tooltip';
import Divider from '@mui/material/Divider';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import ResetFocusIcon from '@mui/icons-material/CenterFocusWeak';
import { useRouter } from 'next/router';
import { CODE_VARIANTS } from 'docs/src/modules/constants';
import { useSetCodeVariant } from 'docs/src/modules/utils/codeVariant';
import { useTranslate } from '@mui/docs/i18n';
import OpenMuiChat from 'docs/src/modules/components/OpenMuiChat';
import stylingSolutionMapping from 'docs/src/modules/utils/stylingSolutionMapping';
import codeSandbox from '../sandbox/CodeSandbox';
import stackBlitz from '../sandbox/StackBlitz';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Root = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return [_defineProperty(_defineProperty(_defineProperty({}, theme.breakpoints.up('sm'), {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  }), '& .MuiIconButton-root', {
    '&:hover': {
      backgroundColor: (theme.vars || theme).palette.grey[100]
    }
  }), '& .MuiSvgIcon-root', {
    fontSize: 16,
    color: (theme.vars || theme).palette.grey[900]
  }), theme.applyDarkStyles({
    '& .MuiIconButton-root': {
      '&:hover': {
        backgroundColor: (theme.vars || theme).palette.primaryDark[700]
      }
    },
    '& .MuiSvgIcon-root': {
      color: (theme.vars || theme).palette.grey[400]
    }
  })];
});
function DemoTooltip(props) {
  return /*#__PURE__*/_jsx(Tooltip, _extends({
    slotProps: {
      popper: {
        sx: {
          zIndex: function zIndex(theme) {
            return theme.zIndex.appBar - 1;
          }
        }
      }
    }
  }, props));
}
var alwaysTrue = function alwaysTrue() {
  return true;
};
var ToggleButtonGroup = styled(MDToggleButtonGroup)(function (_ref3) {
  var theme = _ref3.theme;
  return [theme.unstable_sx(_defineProperty({}, "& .".concat(toggleButtonGroupClasses.grouped), {
    '&:not(:first-of-type)': {
      pr: '2px' // a nudge for optical alignment
    },
    '&:not(:last-of-type)': {
      pl: '2px' // a nudge for optical alignment
    }
  }))];
});
var Button = styled(MDButton)(function (_ref4) {
  var theme = _ref4.theme;
  return _extends({
    height: 26,
    padding: '7px 8px 8px 8px',
    // 7px for optical alignment
    flexShrink: 0,
    borderRadius: 999,
    border: '1px solid',
    borderColor: alpha(theme.palette.grey[200], 0.8),
    fontSize: theme.typography.pxToRem(13),
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.primary[600],
    '& .MuiSvgIcon-root': {
      color: theme.palette.primary.main
    },
    '&:hover': {
      backgroundColor: theme.palette.primary[50],
      borderColor: theme.palette.primary[200],
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    }
  }, theme.applyDarkStyles({
    color: theme.palette.primary[300],
    borderColor: alpha(theme.palette.primary[300], 0.2),
    '& .MuiSvgIcon-root': {
      color: theme.palette.primary[300]
    },
    '&:hover': {
      borderColor: alpha(theme.palette.primary[300], 0.5),
      backgroundColor: alpha(theme.palette.primary[500], 0.2),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    }
  }));
});
var MenuItem = styled(MDMenuItem)(function (_ref5) {
  var theme = _ref5.theme;
  return _defineProperty({
    padding: theme.spacing(1)
  }, "& .".concat(menuItemClasses.selected), {
    backgroundColor: theme.palette.primary[50]
  });
});
var ToggleButton = styled(MDToggleButton)(function (_ref7) {
  var theme = _ref7.theme;
  return [theme.unstable_sx({
    height: 26,
    width: 38,
    p: 0,
    fontSize: theme.typography.pxToRem(13),
    borderRadius: '999px',
    '&.Mui-disabled': {
      opacity: 0.8,
      cursor: 'not-allowed'
    }
  })];
});

/**
 * @param {React.Ref<HTMLElement>[]} controlRefs
 * @param {object} [options]
 * @param {(index: number) => boolean} [options.isFocusableControl] In case certain controls become unfocusable
 * @param {number} [options.defaultActiveIndex]
 */
function useToolbar(controlRefs) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$defaultActiv = options.defaultActiveIndex,
    defaultActiveIndex = _options$defaultActiv === void 0 ? 0 : _options$defaultActiv,
    _options$isFocusableC = options.isFocusableControl,
    isFocusableControl = _options$isFocusableC === void 0 ? alwaysTrue : _options$isFocusableC;
  var _React$useState = React.useState(defaultActiveIndex),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    activeControlIndex = _React$useState2[0],
    setActiveControlIndex = _React$useState2[1];

  // TODO: do we need to do this during layout practically? It's technically
  // a bit too late since we allow user interaction between layout and passive effects
  React.useEffect(function () {
    setActiveControlIndex(function (currentActiveControlIndex) {
      if (!isFocusableControl(currentActiveControlIndex)) {
        return defaultActiveIndex;
      }
      return currentActiveControlIndex;
    });
  }, [defaultActiveIndex, isFocusableControl]);

  // controlRefs.findIndex(controlRef => controlRef.current = element)
  function findControlIndex(element) {
    var controlIndex = -1;
    controlRefs.forEach(function (controlRef, index) {
      if (controlRef.current === element) {
        controlIndex = index;
      }
    });
    return controlIndex;
  }
  function handleControlFocus(event) {
    var nextActiveControlIndex = findControlIndex(event.target);
    if (nextActiveControlIndex !== -1) {
      setActiveControlIndex(nextActiveControlIndex);
    } else {
      // make sure DCE works
      // eslint-disable-next-line no-lonely-if
      if (false) {
        console.error('MUI: The toolbar contains a focusable element that is not controlled by the toolbar. ' + 'Make sure you have attached `getControlProps(index)` to every focusable element within this toolbar.');
      }
    }
  }
  var handleToolbarFocus;
  if (false) {
    handleToolbarFocus = function handleToolbarFocus(event) {
      if (findControlIndex(event.target) === -1) {
        console.error('MUI: The toolbar contains a focusable element that is not controlled by the toolbar. ' + 'Make sure you have attached `getControlProps(index)` to every focusable element within this toolbar.');
      }
    };
  }
  var _useTheme = useTheme(),
    direction = _useTheme.direction;
  function handleToolbarKeyDown(event) {
    // We handle toolbars where controls can be hidden temporarily.
    // When a control is hidden we can't move focus to it and have to exclude
    // it from the order.
    var currentFocusableControlIndex = -1;
    var focusableControls = [];
    controlRefs.forEach(function (controlRef, index) {
      var control = controlRef.current;
      if (index === activeControlIndex) {
        currentFocusableControlIndex = focusableControls.length;
      }
      if (control !== null && isFocusableControl(index)) {
        focusableControls.push(control);
      }
    });
    var prevControlKey = direction === 'ltr' ? 'ArrowLeft' : 'ArrowRight';
    var nextControlKey = direction === 'ltr' ? 'ArrowRight' : 'ArrowLeft';
    var nextFocusableIndex = -1;
    switch (event.key) {
      case prevControlKey:
        nextFocusableIndex = (currentFocusableControlIndex - 1 + focusableControls.length) % focusableControls.length;
        break;
      case nextControlKey:
        nextFocusableIndex = (currentFocusableControlIndex + 1) % focusableControls.length;
        break;
      case 'Home':
        nextFocusableIndex = 0;
        break;
      case 'End':
        nextFocusableIndex = focusableControls.length - 1;
        break;
      default:
        break;
    }
    if (nextFocusableIndex !== -1) {
      event.preventDefault();
      focusableControls[nextFocusableIndex].focus();
    }
  }
  function getControlProps(index) {
    return {
      onFocus: handleControlFocus,
      ref: controlRefs[index],
      tabIndex: index === activeControlIndex ? 0 : -1
    };
  }
  return {
    getControlProps: getControlProps,
    toolbarProps: {
      // TODO: good opportunity to warn on missing `aria-label`
      onFocus: handleToolbarFocus,
      onKeyDown: handleToolbarKeyDown,
      role: 'toolbar'
    }
  };
}
export default function DemoToolbar(props) {
  var codeOpen = props.codeOpen,
    codeVariant = props.codeVariant,
    copyButtonOnClick = props.copyButtonOnClick,
    copyIcon = props.copyIcon,
    hasNonSystemDemos = props.hasNonSystemDemos,
    demo = props.demo,
    demoData = props.demoData,
    demoId = props.demoId,
    demoName = props.demoName,
    demoOptions = props.demoOptions,
    demoSourceId = props.demoSourceId,
    initialFocusRef = props.initialFocusRef,
    onCodeOpenChange = props.onCodeOpenChange,
    onResetDemoClick = props.onResetDemoClick,
    openDemoSource = props.openDemoSource,
    showPreview = props.showPreview;
  var setCodeVariant = useSetCodeVariant();
  var t = useTranslate();
  var hasTSVariant = demo.rawTS;
  var renderedCodeVariant = function renderedCodeVariant() {
    if (codeVariant === CODE_VARIANTS.TS && hasTSVariant) {
      return CODE_VARIANTS.TS;
    }
    return CODE_VARIANTS.JS;
  };
  var handleCodeLanguageClick = function handleCodeLanguageClick(event, clickedCodeVariant) {
    if (clickedCodeVariant !== null && codeVariant !== clickedCodeVariant) {
      setCodeVariant(clickedCodeVariant);
    }
  };
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    anchorEl = _React$useState4[0],
    setAnchorEl = _React$useState4[1];
  var handleMoreClick = function handleMoreClick(event) {
    setAnchorEl(event.currentTarget);
  };
  var handleMoreClose = function handleMoreClose() {
    setAnchorEl(null);
  };
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    snackbarOpen = _React$useState6[0],
    setSnackbarOpen = _React$useState6[1];
  var _React$useState7 = React.useState(undefined),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    snackbarMessage = _React$useState8[0],
    setSnackbarMessage = _React$useState8[1];
  var handleSnackbarClose = function handleSnackbarClose() {
    setSnackbarOpen(false);
  };
  var createHandleCodeSourceLink = function createHandleCodeSourceLink(anchor, codeVariantParam, stylingSolution) {
    return /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return copy("".concat(window.location.href.split('#')[0], "#").concat(stylingSolution ? "".concat(stylingSolutionMapping[stylingSolution], "-") : '').concat(anchor).concat(codeVariantParam === CODE_VARIANTS.TS ? '.tsx' : '.js'));
          case 3:
            setSnackbarMessage(t('copiedSourceLink'));
            setSnackbarOpen(true);
          case 5:
            _context.prev = 5;
            handleMoreClose();
            return _context.finish(5);
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0,, 5, 8]]);
    }));
  };
  var handleResetFocusClick = function handleResetFocusClick() {
    initialFocusRef.current.focusVisible();
  };
  var showCodeLabel;
  if (codeOpen) {
    showCodeLabel = showPreview ? t('hideFullSource') : t('hideSource');
  } else {
    showCodeLabel = showPreview ? t('showFullSource') : t('showSource');
  }
  var controlRefs = [React.useRef(null), React.useRef(null), React.useRef(null), React.useRef(null), React.useRef(null), React.useRef(null), React.useRef(null), React.useRef(null), React.useRef(null), React.useRef(null)];
  // if the code is not open we hide the language controls
  var isFocusableControl = React.useCallback(function (index) {
    return codeOpen ? true : index !== 1 && index !== 2;
  }, [codeOpen]);
  var _useToolbar = useToolbar(controlRefs, {
      defaultActiveIndex: 0,
      isFocusableControl: isFocusableControl
    }),
    getControlProps = _useToolbar.getControlProps,
    toolbarProps = _useToolbar.toolbarProps;
  var devMenuItems = [];
  if (process.env.DEPLOY_ENV === 'staging' || process.env.DEPLOY_ENV === 'pull-request') {
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- valid reason to disable rules of hooks
    // eslint-disable-next-line react-hooks/rules-of-hooks -- process.env never changes
    var router = useRouter();
    if (process.env.PULL_REQUEST_ID) {
      devMenuItems.push(/*#__PURE__*/_jsxs(MenuItem, {
        "data-ga-event-category": "demo",
        "data-ga-event-label": demo.gaLabel,
        "data-ga-event-action": "link-deploy-preview",
        component: "a",
        href: "https://deploy-preview-".concat(process.env.PULL_REQUEST_ID, "--").concat(process.env.NETLIFY_SITE_NAME, ".netlify.app").concat(router.route, "/#").concat(demoName),
        target: "_blank",
        rel: "noopener nofollow",
        onClick: handleMoreClose,
        children: ["demo on PR #", process.env.PULL_REQUEST_ID]
      }, "link-deploy-preview"));
    }
    devMenuItems.push(/*#__PURE__*/_jsxs(MenuItem, {
      "data-ga-event-category": "demo",
      "data-ga-event-label": demo.gaLabel,
      "data-ga-event-action": "link-next",
      component: "a",
      href: "https://next--".concat(process.env.NETLIFY_SITE_NAME, ".netlify.app").concat(router.route, "/#").concat(demoName),
      target: "_blank",
      rel: "noopener nofollow",
      onClick: handleMoreClose,
      children: ["demo on\xA0", /*#__PURE__*/_jsx("code", {
        children: "next"
      })]
    }, "link-next"), /*#__PURE__*/_jsx(MenuItem, {
      "data-ga-event-category": "demo",
      "data-ga-event-label": demo.gaLabel,
      "data-ga-event-action": "permalink",
      component: "a",
      href: "".concat(process.env.NETLIFY_DEPLOY_URL).concat(router.route, "#").concat(demoName),
      target: "_blank",
      rel: "noopener nofollow",
      onClick: handleMoreClose,
      children: "demo permalink"
    }, "permalink"), /*#__PURE__*/_jsxs(MenuItem, {
      "data-ga-event-category": "demo",
      "data-ga-event-label": demo.gaLabel,
      "data-ga-event-action": "link-master",
      component: "a",
      href: "https://master--".concat(process.env.NETLIFY_SITE_NAME, ".netlify.app").concat(router.route, "/#").concat(demoName),
      target: "_blank",
      rel: "noopener nofollow",
      onClick: handleMoreClose,
      children: ["demo on\xA0", /*#__PURE__*/_jsx("code", {
        children: "master"
      })]
    }, "link-master"));
  }
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsxs(Root, _extends({
      "aria-label": t('demoToolbarLabel')
    }, toolbarProps, {
      children: [/*#__PURE__*/_jsx(OpenMuiChat, {
        "data-ga-event-category": "mui-chat",
        "data-ga-event-label": demo.gaLabel,
        "data-ga-event-action": "open-in-mui-chat",
        demoData: demoData
      }), /*#__PURE__*/_jsx(Fade, {
        "in": codeOpen,
        children: /*#__PURE__*/_jsxs(Box, {
          sx: {
            display: 'flex'
          },
          children: [hasNonSystemDemos && /*#__PURE__*/_jsx(Divider, {
            orientation: "vertical",
            variant: "middle",
            sx: {
              mx: 1,
              height: '24px'
            }
          }), /*#__PURE__*/_jsxs(ToggleButtonGroup, {
            sx: {
              margin: '8px 0'
            },
            exclusive: true,
            value: renderedCodeVariant(),
            onChange: handleCodeLanguageClick,
            children: [/*#__PURE__*/_jsx(ToggleButton, _extends({
              value: CODE_VARIANTS.JS,
              "aria-label": t('showJSSource'),
              "data-ga-event-category": "demo",
              "data-ga-event-action": "source-js",
              "data-ga-event-label": demo.gaLabel
            }, getControlProps(1), {
              children: "JS"
            })), /*#__PURE__*/_jsx(ToggleButton, _extends({
              value: CODE_VARIANTS.TS,
              disabled: !hasTSVariant,
              "aria-label": t('showTSSource'),
              "data-ga-event-category": "demo",
              "data-ga-event-action": "source-ts",
              "data-ga-event-label": demo.gaLabel
            }, getControlProps(2), {
              children: "TS"
            }))]
          })]
        })
      }), /*#__PURE__*/_jsxs(Box, {
        sx: {
          ml: 'auto'
        },
        children: [/*#__PURE__*/_jsx(Button, _extends({
          "aria-controls": openDemoSource ? demoSourceId : null,
          "data-ga-event-category": "demo",
          "data-ga-event-label": demo.gaLabel,
          "data-ga-event-action": "expand",
          onClick: onCodeOpenChange
        }, getControlProps(3), {
          sx: {
            mr: 0.5
          },
          children: showCodeLabel
        })), demoOptions.hideEditButton ? null : /*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsx(DemoTooltip, {
            title: t('stackblitz'),
            placement: "bottom",
            children: /*#__PURE__*/_jsx(IconButton, _extends({
              "data-ga-event-category": "demo",
              "data-ga-event-label": demo.gaLabel,
              "data-ga-event-action": "stackblitz",
              onClick: function onClick() {
                return stackBlitz.createReactApp(demoData).openSandbox();
              }
            }, getControlProps(4), {
              sx: {
                borderRadius: 1
              },
              children: /*#__PURE__*/_jsx(SvgIcon, {
                viewBox: "0 0 19 28",
                children: /*#__PURE__*/_jsx("path", {
                  d: "M8.13378 16.1087H0L14.8696 0L10.8662 11.1522L19 11.1522L4.13043 27.2609L8.13378 16.1087Z"
                })
              })
            }))
          }), /*#__PURE__*/_jsx(DemoTooltip, {
            title: t('codesandbox'),
            placement: "bottom",
            children: /*#__PURE__*/_jsx(IconButton, _extends({
              "data-ga-event-category": "demo",
              "data-ga-event-label": demo.gaLabel,
              "data-ga-event-action": "codesandbox",
              onClick: function onClick() {
                return codeSandbox.createReactApp(demoData).openSandbox();
              }
            }, getControlProps(5), {
              sx: {
                borderRadius: 1
              },
              children: /*#__PURE__*/_jsx(SvgIcon, {
                viewBox: "0 0 1024 1024",
                children: /*#__PURE__*/_jsx("path", {
                  d: "M755 140.3l0.5-0.3h0.3L512 0 268.3 140h-0.3l0.8 0.4L68.6 256v512L512 1024l443.4-256V256L755 140.3z m-30 506.4v171.2L548 920.1V534.7L883.4 341v215.7l-158.4 90z m-584.4-90.6V340.8L476 534.4v385.7L300 818.5V646.7l-159.4-90.6zM511.7 280l171.1-98.3 166.3 96-336.9 194.5-337-194.6 165.7-95.7L511.7 280z"
                })
              })
            }))
          })]
        }), /*#__PURE__*/_jsx(DemoTooltip, {
          title: t('copySource'),
          placement: "bottom",
          children: /*#__PURE__*/_jsx(IconButton, _extends({
            "data-ga-event-category": "demo",
            "data-ga-event-label": demo.gaLabel,
            "data-ga-event-action": "copy",
            onClick: copyButtonOnClick
          }, getControlProps(6), {
            sx: {
              borderRadius: 1
            },
            children: copyIcon
          }))
        }), /*#__PURE__*/_jsx(DemoTooltip, {
          title: t('resetFocus'),
          placement: "bottom",
          children: /*#__PURE__*/_jsx(IconButton, _extends({
            "data-ga-event-category": "demo",
            "data-ga-event-label": demo.gaLabel,
            "data-ga-event-action": "reset-focus",
            onClick: handleResetFocusClick
          }, getControlProps(7), {
            sx: {
              borderRadius: 1
            },
            children: /*#__PURE__*/_jsx(ResetFocusIcon, {})
          }))
        }), /*#__PURE__*/_jsx(DemoTooltip, {
          title: t('resetDemo'),
          placement: "bottom",
          children: /*#__PURE__*/_jsx(IconButton, _extends({
            "aria-controls": demoId,
            "data-ga-event-category": "demo",
            "data-ga-event-label": demo.gaLabel,
            "data-ga-event-action": "reset",
            onClick: onResetDemoClick
          }, getControlProps(8), {
            sx: {
              borderRadius: 1
            },
            children: /*#__PURE__*/_jsx(RefreshRoundedIcon, {})
          }))
        }), /*#__PURE__*/_jsx(IconButton, _extends({
          onClick: handleMoreClick,
          "aria-label": t('seeMore'),
          "aria-owns": anchorEl ? 'demo-menu-more' : undefined,
          "aria-haspopup": "true"
        }, getControlProps(9), {
          sx: {
            borderRadius: 1
          },
          children: /*#__PURE__*/_jsx(MoreVertIcon, {})
        }))]
      })]
    })), /*#__PURE__*/_jsxs(Menu, {
      id: "demo-menu-more",
      anchorEl: anchorEl,
      open: Boolean(anchorEl),
      onClose: handleMoreClose,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'right'
      },
      children: [/*#__PURE__*/_jsx(MenuItem, {
        "data-ga-event-category": "demo",
        "data-ga-event-label": demo.gaLabel,
        "data-ga-event-action": "github",
        component: "a",
        href: demoData.githubLocation,
        target: "_blank",
        rel: "noopener nofollow",
        onClick: handleMoreClose,
        children: t('viewGitHub')
      }), /*#__PURE__*/_jsx(MenuItem, {
        "data-ga-event-category": "demo",
        "data-ga-event-label": demo.gaLabel,
        "data-ga-event-action": "copy-js-source-link",
        onClick: createHandleCodeSourceLink(demoName, CODE_VARIANTS.JS),
        children: t('copySourceLinkJS')
      }), /*#__PURE__*/_jsx(MenuItem, {
        "data-ga-event-category": "demo",
        "data-ga-event-label": demo.gaLabel,
        "data-ga-event-action": "copy-ts-source-link",
        onClick: createHandleCodeSourceLink(demoName, CODE_VARIANTS.TS),
        children: t('copySourceLinkTS')
      }), devMenuItems]
    }), /*#__PURE__*/_jsx(Snackbar, {
      open: snackbarOpen,
      autoHideDuration: 3000,
      onClose: handleSnackbarClose,
      message: snackbarMessage
    })]
  });
}
false ? void 0 : void 0;